import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import resolve from "ioc/resolve";
import csvParser from 'webutils/services/csv-json';

export default class ProductPickerImportItemsController {
	constructor($rootScope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.title = options.title || "Import item(s)";
		$ctrl.results = [];
		$ctrl.parts = [];
	}

	save() {
		const $ctrl = this;
		$ctrl.lines = [];
		$ctrl.bus.validationErrors = [];
		$ctrl.$close($ctrl.results);
	}

	processText(text) {
		let $ctrl = this;

		var content = {
			csv: text.replace(/\r\n|\r/g, "\n"),
			header: false,
			separator: ","
		};
		$ctrl.content = content.csv;
		var lines = content.csv.split(
			new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
		);
		var columncount = lines[0].split(content.separator).length;

		var header = "id\r\n";
		if (columncount > 1) header = "id,qty\r\n";

		text = header + text;
		$ctrl.finished = false;
		$ctrl.parts = [];


		$ctrl.parts = csvParser.parse(text);
		console.debug("BL*** parts", $ctrl.parts);
		//console.debug("parts", $ctrl.parts);
		//console.debug("text", text);
		$ctrl.finished = false;
		resolve('$rootScope').$apply();
		$ctrl.$close($ctrl.parts);
	}

}
